var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 9.06564V7.80294C0.0157227 7.71437 0.0382807 7.62717 0.0464839 7.53859C0.200976 5.94357 0.696581 4.46872 1.64951 3.17512C2.99756 1.34597 4.80498 0.286512 7.07178 0.0647342C9.62295 -0.185196 11.699 0.765086 13.3882 2.6478C13.5987 2.88194 13.7929 3.12843 13.9822 3.35708C14.3985 2.90597 14.7711 2.44113 15.2045 2.0422C17.3346 0.07984 19.8208 -0.477009 22.5518 0.409417C25.3545 1.31988 26.9951 3.37287 27.7211 6.19144C27.8578 6.7174 27.9091 7.26532 28 7.80294V9.06564C27.9827 9.12628 27.9692 9.18797 27.9597 9.25034C27.8161 10.9174 27.2132 12.4163 26.3108 13.8074C25.3606 15.2734 24.2006 16.5656 22.9079 17.7212C20.3383 20.02 17.7304 22.2755 15.1286 24.5379C14.3931 25.1772 13.5748 25.147 12.8078 24.4857C10.8108 22.7651 8.81699 21.0405 6.82637 19.3121C5.15498 17.8544 3.5335 16.3397 2.20117 14.5483C1.33574 13.381 0.639844 12.1252 0.294629 10.7032C0.164062 10.1642 0.0963867 9.61013 0 9.06564Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.c59c80036f2deb97964c004a1cf63750.svg";
export { ForwardRef as ReactComponent };